import CryptoJS from "crypto-js";

export const encrypt = (itemToEncrypt, key) => {
    const parseKey = CryptoJS.enc.Hex.parse(key);
    const iv = CryptoJS.enc.Hex.parse(import.meta.env.VITE_IV);
    const encrypted = CryptoJS.AES.encrypt(itemToEncrypt, parseKey, { 'mode': CryptoJS.mode.CBC, iv: iv });
    const encryptedString = encrypted.toString();
    return encryptedString;
}

export const decrypt = (itemToDescrypt, key) => {
    var parseKey = CryptoJS.enc.Hex.parse(key);
    const iv = CryptoJS.enc.Hex.parse(import.meta.env.VITE_IV);
    var decrypted = CryptoJS.AES.decrypt(itemToDescrypt, parseKey, { 'mode': CryptoJS.mode.CBC, iv: iv });
    var decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
    return decryptedString;
}

export const isEmpty = (value) => {
    if (value && value !== null && value !== '' && value !== 'null' && value !== 'undefined' && value !== 0 && value !== '0' && value !== 'false')
        return false; //Not empty 
    else
        return true //Is empty
}

const normalize = (str) => {
    if (typeof str === "string") {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    }
    return str;
}

const getTranslatedText = (text, language, translations, userCountry) => {

    if (text) {

        if (userCountry === 'Chile' && typeof text === 'string' && text.includes('R$')) {
            text = text.replace(/R\$/g, 'UF');
        }

        const translatedElement = translations.find((element) => {
            if (normalize(element.text_pt) === normalize(text)) {
                return true;
            }

        })
        if (translatedElement) {
            return translatedElement[language]
        } else {
            return text
        }
    } else {
        return
    }

}

export function translateText(text, selectLanguage = 'text_pt', translations, userCountry) {
    switch (selectLanguage) {
        case "ES":
            return getTranslatedText(text, "text_es", translations, userCountry)
        case "PT-BR":
            return getTranslatedText(text, "text_pt", translations, userCountry)
        case "EN":
            return getTranslatedText(text, "text_en", translations, userCountry)
        default:
            break;
    }
}

export const getCoinCountryLabel = (country) => {
    switch (country) {
        case "Chile":
            return "UF"
        case "Brasil":
            return "R$"
        default:
            return "R$"
    }
}

export const getImageLabel = (imageName, language, translations, userCountry) => {
    const keywords = [
        'Área de Convivência Externa', 'Edificio', 'Edifício', 'Planta', 'Complexo inteiro',
        'Fachada', 'Edificio', 'Folheto', 'Andar', 'Tipo', 'Pavimento',
        'Superior', 'Duplex', 'Sala', 'Foto', 'Conjunto', 'Matricula',
        'Jardim', 'Imagem', 'de reunião', 'Terréo', 'de entrada', 'Hall', 'Outros'
    ];

    const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    keywords.sort((a, b) => b.length - a.length);

    for (const key of keywords) {
        const lowerName = imageName.toLowerCase();
        const lowerKey = key.toLowerCase();

        if (lowerName.includes(lowerKey) && lowerName !== lowerKey) {
            const translatedKey = translateText(key, language, translations, userCountry);
            const regex = new RegExp(escapeRegExp(key), 'gi');
            return imageName.replace(regex, translatedKey);
        }
    }

    return translateText(imageName, language, translations, userCountry);
};